import {CommonModule} from '@angular/common';
import {Component, ElementRef, HostListener} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faBars} from '@fortawesome/free-solid-svg-icons';
// import * as bootstrap from 'bootstrap';

declare var bootstrap: any;

@Component({
    selector: 'app-nav-header',
    imports: [RouterOutlet, CommonModule, FontAwesomeModule],
    templateUrl: './nav-header.component.html',
    styleUrl: './nav-header.component.css'
})
export class NavHeaderComponent {
  isCollapsed = true;
  

  constructor( private router: Router, private library: FaIconLibrary, private eRef: ElementRef ){
    library.addIcons(faBars)


  }
  // Method to close the navbar
  closeNavbar(navbarCollapse: HTMLElement): void {
    const navbar = new bootstrap.Collapse(navbarCollapse, { toggle: false });
    navbar.hide();
  }

  toggleNavbar(navbarCollapse: HTMLElement) {
    const collapse = new bootstrap.Collapse(navbarCollapse, {
      toggle: true
    });
  }

  // Close the navbar if clicked outside
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {

    const navbar = document.querySelector('.navbar-collapse.show');
    if (navbar && this.eRef.nativeElement.contains(event.target)) {
      const bsNavbar = new bootstrap.Collapse(navbar, { toggle: false });
      bsNavbar.hide();
    }
  }
  login(){
    this.router.navigate(['/login'])
  }

}
